import React from "react";
import { Hero, Section, Cards, CTA } from "../components/Page/Page.js";

export default function AboutScreen() {
  return (
    <>
      <Hero title="About Alphabet Greens" text="We develop carbon-offset projects and help organisations measure, reduce and offset their emissions." />
      <Section title="Who we are">
        <p>Alphabet Greens is an India-based climate and sustainability organisation that develops and implements carbon projects. As project developer and owner, we handle design, implementation, monitoring, documentation, coordination with validation and verification bodies, credit issuance and stakeholder management, and we facilitate the sale and retirement of the credits our projects generate. Our programme is registered under the Gold Standard mechanism.</p>
      </Section>
      <Section title="What we stand for" alt>
        <Cards items={[
          ["Integrity", "Independent validation and certification of every credit."],
          ["Community", "Projects designed around local benefit."],
          ["Transparency", "Open documentation and public registry retirement."],
        ]} />
      </Section>
      <CTA />
    </>
  );
}
